import { selectJsonQuery } from '../results';

import type { IAppState } from 'shared/common/state';

export const selectIsEtazhiBlackFridayFilterEnabled = (state: IAppState): boolean => {
  const jsonQuery = selectJsonQuery(state);
  const isEnabled = !!jsonQuery?.is_black_friday_etazhi;

  return isEnabled;
};
